import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.editPODisclaimerLabel.editablePODisclaimerLabelTextField`

export default defineMessages({
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Label description',
  },
  descriptionAriaLabel: {
    id: `${scope}.descriptionAriaLabel`,
    defaultMessage: 'Label description',
  },
  descriptionStatusIconIdleAriaLabel: {
    id: `${scope}.descriptionStatusIconIdleAriaLabel`,
    defaultMessage: 'Edit label description',
  },
  descriptionStatusIconPendingAriaLabel: {
    id: `${scope}.descriptionStatusIconPendingAriaLabel`,
    defaultMessage: 'Saving label description',
  },
  descriptionStatusIconResolvedAriaLabel: {
    id: `${scope}.descriptionStatusIconResolvedAriaLabel`,
    defaultMessage: 'Label description saved',
  },
  descriptionStatusIconRejectedAriaLabel: {
    id: `${scope}.descriptionStatusIconRejectedAriaLabel`,
    defaultMessage: 'Failed to save label description',
  },
  contentPlaceholder: {
    id: `${scope}.contentPlaceholder`,
    defaultMessage: 'Label content',
  },
  contentAriaLabel: {
    id: `${scope}.contentAriaLabel`,
    defaultMessage: 'Label content',
  },
  contentStatusIconIdleAriaLabel: {
    id: `${scope}.contentStatusIconIdleAriaLabel`,
    defaultMessage: 'Edit label content',
  },
  contentStatusIconPendingAriaLabel: {
    id: `${scope}.contentStatusIconPendingAriaLabel`,
    defaultMessage: 'Saving label content',
  },
  contentStatusIconResolvedAriaLabel: {
    id: `${scope}.contentStatusIconResolvedAriaLabel`,
    defaultMessage: 'Label content saved',
  },
  contentStatusIconRejectedAriaLabel: {
    id: `${scope}.contentStatusIconRejectedAriaLabel`,
    defaultMessage: 'Failed to save label content',
  },
})
